module.exports = __webpack_public_path__ + "img/Girl_020027.1077e4c7.png";